<template>
  <div id="RemoteHands">
    <MyBanner :text="$t('banner.RemoteHandsPage')" />
    <MyHeaderPage
      :title="$t('remoteHands.title')"
      button="rh"
      :hasColocation="hasColocation"
    />

    <br /><br />

    <div
      v-if="!hasColocation && viewLoader"
      style="margin: 20px 0; text-align: center; font-size: 18px; color: #001831;"
    >
      {{ $t('noSolutionsServices.colocation') }}
    </div>

    <TicketsList
      v-if="hasColocation && viewLoader"
      ticket-type="RemoteHand"
      details-url="listRemoteHandsUrl"
    />

    <MyLoading v-else :viewLoader="viewLoader" type="" />
  </div>
</template>

<script>
import MyBanner from "@/components/MyBanner.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import TicketsList from "@/components/TicketsList.vue";
import "@/assets/scss/RemoteHands.scss";
import MyLoading from "@/components/MyLoading.vue";

export default {
  name: "RemoteHandsList",
  props: ["openModal"],
  components: {
    MyBanner,
    MyHeaderPage,
    TicketsList,
    MyLoading,
  },
  data() {
    return {
      hasColocation: true,
      viewLoader: false,
    };
  },
  methods: {
    checkColocationAssets() {
      const headers = {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      };

      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "assets/v1/has-assets/colocation",
          { headers }
        )
        .then((response) => {
          this.hasColocation = response.data.hasAssets || false;
          this.viewLoader = true;
        })
        .catch((error) => {
          const status = error?.response?.status ?? error?.request?.status;

          if (status === 403) {
            this.hasColocation = false;
            this.viewLoader = true;
            return;
          }

          this.viewLoader = true;
          console.error("Error checking colocation assets:", error);
        });
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$IsLoggedIn();
    this.checkColocationAssets();
    // return this.$router.push('/lista-remote-hands/dettaglio/1234')
  },
};
</script>
